import { withStyles } from '@material-ui/core';
import Label from '../../../../ProDetails/common/Label';
import Value from '../../../../ProDetails/common/Value';
import { getCustomLabel } from '../../../../utils';
import appConstants from '../../../../../../../../appConstants';

const styles = (theme) => ({
  container: {
    margin: '16px 0px'
  },
  valueContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    marginTop: 8
  },
  value: {
    marginLeft: 0,
    marginRight: 8,
    padding: 8,
    marginBottom: 6,
    backgroundColor: theme.radioLabel,
    fontSize: theme.headerTextFontSize,
    fontWeight: 400,
    color: theme.radioLabelText,
    borderRadius: '12px'
  }
});

const ExpediteShipment = ({ classes, priority, staticClientData }) => {
  const expediteLabel = getCustomLabel(
    appConstants.CUSTOM_LABELS.GUARANTEED_SHIPMENT,
    staticClientData
  );
  return (
    <div className={classes.container}>
      <Label labelText={`${expediteLabel} SHIPMENT`} />
      <div className={classes.valueContainer}>
        {priority ? <div className={classes.value}>{priority}</div> : <Value value="NA" />}
      </div>
    </div>
  );
};

export default withStyles(styles)(ExpediteShipment);
